import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import 'react';
import { getDefaultThemedOptions, themed } from '@indeed/ifl-css';
import { useStepperContext, StepProvider, useStep } from './context.js';
import transparentize from '../../utils/transparentize.js';
import transition from '../../utils/transition.js';
import { StyledLabelChildren, StyledCircle } from './StepLabel.js';
import { jsx } from '@emotion/react';
import '@indeed/ifl-icons/Check';
import '@indeed/ifl-icons/Error';
import 'focus-visible';
import '../Stack/Stack.js';
import '../../utils/displayName.js';
import '../IconWrapper/IconWrapper.js';

const themedOptions = getDefaultThemedOptions("active", "complete", "invalid", "nextActive", "nextComplete", "nextDisabled", "variant", "vertical");
const StyledListItem = /*#__PURE__*/themed("li", process.env.NODE_ENV === "production" ? _extends({}, {
  target: "eqy5jub0"
}, themedOptions) : _extends({}, {
  target: "eqy5jub0",
  label: "StyledListItem"
}, themedOptions))(_ref => {
  let {
    active,
    complete,
    invalid,
    nextActive,
    nextComplete,
    nextDisabled,
    variant,
    vertical
  } = _ref;
  return {
    fontWeight: active ? "bold" : "normal",
    transition: _ref2 => {
      let {
        transitions
      } = _ref2;
      return transition(transitions.slow, "border-color", "box-shadow", "opacity");
    },
    "@media (prefers-reduced-motion: reduce)": {
      transition: "none"
    },
    textAlign: vertical ? "start" : "center",
    flex: vertical ? "0" : "1 0",
    margin: variant === "segmented" ? ".25rem" : undefined,
    paddingInlineStart: vertical && variant === "segmented" ? ".75rem" : undefined,
    paddingBlockStart: !vertical && variant === "segmented" ? ".5rem" : undefined,
    fontFamily: "default",
    fontSize: "2",
    minBlockSize: vertical ? "3rem" : "initial",
    minInlineSize: vertical ? undefined : 0,
    position: "relative",
    counterIncrement: "step",
    "&[disabled]": {
      pointerEvents: "none",
      userSelect: "none",
      [`${StyledLabelChildren}`]: {
        opacity: 0.4
      },
      [`${StyledCircle}`]: {
        borderColor: _ref3 => {
          let {
            colors
          } = _ref3;
          return transparentize(0.6, colors.border.action["[base]"]);
        },
        // number
        "&::before": {
          opacity: 0.4
        }
      },
      // gray track
      "::before": {
        opacity: 0.4
      }
    },
    // gray tracks
    ...(variant !== "segmented" && {
      "&:not(:last-of-type)::before": {
        content: '""',
        position: "absolute",
        top: vertical ? 0 : "0.6875rem",
        left: vertical ? "0.6875rem" : "50%",
        inlineSize: vertical ? ".125rem" : "100%",
        blockSize: vertical ? "100%" : ".125rem",
        backgroundColor: "border",
        // Uses border token since it's perceived as a line
        transition: _ref4 => {
          let {
            transitions
          } = _ref4;
          return transition(transitions.slow, "opacity");
        },
        "@media (prefers-reduced-motion: reduce)": {
          transition: "none"
        },
        ...(nextDisabled && {
          opacity: 0.4
        })
      }
    }),
    // blue tracks
    ...(variant === "linear" && {
      "&:not(:last-of-type)::after": {
        content: '""',
        position: "absolute",
        top: vertical ? 0 : "0.625rem",
        right: vertical ? "100%" : undefined,
        left: vertical ? "0.625rem" : "50%",
        inlineSize: vertical ? ".25rem" : !vertical && (nextActive || nextComplete) ? "100%" : "0%",
        blockSize: vertical && (nextActive || nextComplete) ? "100%" : vertical && !active ? "0%" : ".25rem",
        backgroundColor: "border.primary",
        // Uses border token since it's perceived as a line
        transition: _ref5 => {
          let {
            transitions
          } = _ref5;
          return vertical ? transition(transitions.slow, "block-size") : transition(transitions.slow, "inline-size");
        },
        "@media (prefers-reduced-motion: reduce)": {
          transition: "none"
        }
      }
    }),
    // segmented tracks
    ...(variant === "segmented" && {
      "::before": {
        content: '""',
        display: "block",
        position: "absolute",
        top: 0,
        left: 0,
        right: !vertical ? 0 : undefined,
        bottom: !vertical ? undefined : 0,
        blockSize: vertical ? undefined : !active ? ".25rem" : ".5rem",
        marginBlockStart: vertical ? undefined : !active ? 0 : "-.25rem",
        inlineSize: !vertical ? undefined : !active ? ".25rem" : ".5rem",
        marginInlineStart: !vertical ? undefined : !active ? 0 : "-.25rem",
        backgroundColor: "border.primary",
        // Uses border token since it's perceived as a line
        borderRadius: "full",
        bg: invalid ? "border.status.critical.strong" : complete ? "border.primary" : active ? "border.primary" : "border",
        transition: _ref6 => {
          let {
            transitions
          } = _ref6;
          return vertical ? transition(transitions.slow, "inline-size", "background", "margin-inline-start") : transition(transitions.slow, "block-size", "background", "margin-block-start");
        },
        "@media (prefers-reduced-motion: reduce)": {
          transition: "none"
        }
      }
    })
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const InternalStep = _ref7 => {
  var _stepsArray, _stepsArray2;
  let {
    complete,
    invalid,
    index,
    ...props
  } = _ref7;
  const {
    activeIndex,
    stepsArray,
    variant,
    vertical
  } = useStepperContext();
  const active = activeIndex === index;
  const nextStepActive = activeIndex === index + 1;
  const nextStepComplete = (_stepsArray = stepsArray[index + 1]) == null ? void 0 : _stepsArray.props.complete;
  const nextStepDisabled = (_stepsArray2 = stepsArray[index + 1]) == null ? void 0 : _stepsArray2.props.disabled;
  const stepContextValue = useStep({
    active,
    complete,
    invalid
  });
  return jsx(StepProvider, {
    value: stepContextValue
  }, jsx(StyledListItem, _extends({
    "aria-current": active ? "step" : undefined,
    active: active,
    complete: complete,
    invalid: invalid,
    nextActive: nextStepActive,
    nextComplete: nextStepComplete,
    nextDisabled: nextStepDisabled,
    variant: variant,
    vertical: vertical
  }, props)));
};
InternalStep.displayName = "Step";
const Step = InternalStep;

export { Step, StyledListItem };
